function getFocusableElements(container) {
	return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"))
}
document.querySelectorAll('[id^="Details-"] summary').forEach(summary => {
	summary.setAttribute("role", "button"), summary.setAttribute("aria-expanded", summary.parentNode.hasAttribute("open")), summary.nextElementSibling.getAttribute("id") && summary.setAttribute("aria-controls", summary.nextElementSibling.id), summary.addEventListener("click", event => {
		event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"))
	}), !summary.closest("header-drawer") && summary.parentElement.addEventListener("keyup", onKeyUpEscape)
});
const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container),
		first = elements[0],
		last = elements[elements.length - 1];
	removeTrapFocus(), trapFocusHandlers.focusin = event => {
		event.target !== container && event.target !== last && event.target !== first || document.addEventListener("keydown", trapFocusHandlers.keydown)
	}, trapFocusHandlers.focusout = function() {
		document.removeEventListener("keydown", trapFocusHandlers.keydown)
	}, trapFocusHandlers.keydown = function(event) {
		event.code.toUpperCase() === "TAB" && (event.target === last && !event.shiftKey && (event.preventDefault(), first.focus()), (event.target === container || event.target === first) && event.shiftKey && (event.preventDefault(), last.focus()))
	}, document.addEventListener("focusout", trapFocusHandlers.focusout), document.addEventListener("focusin", trapFocusHandlers.focusin), elementToFocus?.focus()
}
try {
	document.querySelector(":focus-visible")
} catch {
	focusVisiblePolyfill()
}

function focusVisiblePolyfill() {
	const navKeys = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"];
	let currentFocusedElement = null,
		mouseClick = null;
	window.addEventListener("keydown", event => {
		navKeys.includes(event.code.toUpperCase()) && (mouseClick = !1)
	}), window.addEventListener("mousedown", event => {
		mouseClick = !0
	}), window.addEventListener("focus", () => {
		currentFocusedElement && currentFocusedElement.classList.remove("focused"), !mouseClick && (currentFocusedElement = document.activeElement, currentFocusedElement.classList.add("focused"))
	}, !0)
}

function pauseAllMedia() {
	document.querySelectorAll(".js-youtube").forEach(video => {
		video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*")
	}), document.querySelectorAll(".js-vimeo").forEach(video => {
		video.contentWindow.postMessage('{"method":"pause"}', "*")
	}), document.querySelectorAll("video").forEach(video => video.pause()), document.querySelectorAll("product-model").forEach(model => {
		model.modelViewerUI && model.modelViewerUI.pause()
	})
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener("focusin", trapFocusHandlers.focusin), document.removeEventListener("focusout", trapFocusHandlers.focusout), document.removeEventListener("keydown", trapFocusHandlers.keydown), elementToFocus && elementToFocus.focus()
}

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== "ESCAPE") return;
	const openDetailsElement = event.target.closest("details[open]");
	if (!openDetailsElement) return;
	const summaryElement = openDetailsElement.querySelector("summary");
	openDetailsElement.removeAttribute("open"), summaryElement.setAttribute("aria-expanded", !1), summaryElement.focus()
}
class QuantityInput extends HTMLElement {
	constructor() {
		super(), this.input = this.querySelector("input"), this.changeEvent = new Event("change", {
			bubbles: !0
		}), this.querySelectorAll("button").forEach(button => button.addEventListener("click", this.onButtonClick.bind(this)))
	}
	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.value;
		event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown(), previousValue !== this.input.value && this.input.dispatchEvent(this.changeEvent), setTimeout(function() {
			if ($("cart-drawer .totals__subtotal-value").length) {
				var cartTotal = document.querySelector("cart-drawer .totals__subtotal-value").innerHTML;
				console.log("total", cartTotal), cartTotal && (cartTotal = parseFloat(cartTotal.replace("$", "")), showShippingThresholdMessage(cartTotal))
			}
		}, 1e3)
	}
}
customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t), t = setTimeout(() => fn.apply(this, args), wait)
	}
}

function fetchConfig(type = "json") {
	return {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: `application/${type}`
		}
	}
}
typeof window.Shopify > "u" && (window.Shopify = {}), Shopify.bind = function(fn, scope) {
	return function() {
		return fn.apply(scope, arguments)
	}
}, Shopify.setSelectorByValue = function(selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i];
		if (value == option.value || value == option.innerHTML) return selector.selectedIndex = i, i
	}
}, Shopify.addListener = function(target, eventName, callback) {
	target.addEventListener ? target.addEventListener(eventName, callback, !1) : target.attachEvent("on" + eventName, callback)
}, Shopify.postLink = function(path, options) {
	options = options || {};
	var method = options.method || "post",
		params = options.parameters || {},
		form = document.createElement("form");
	form.setAttribute("method", method), form.setAttribute("action", path);
	for (var key in params) {
		var hiddenField = document.createElement("input");
		hiddenField.setAttribute("type", "hidden"), hiddenField.setAttribute("name", key), hiddenField.setAttribute("value", params[key]), form.appendChild(hiddenField)
	}
	document.body.appendChild(form), form.submit(), document.body.removeChild(form)
}, Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
	this.countryEl = document.getElementById(country_domid), this.provinceEl = document.getElementById(province_domid), this.provinceContainer = document.getElementById(options.hideElement || province_domid), Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)), this.initCountry(), this.initProvince()
}, Shopify.CountryProvinceSelector.prototype = {
	initCountry: function() {
		var value = this.countryEl.getAttribute("data-default");
		Shopify.setSelectorByValue(this.countryEl, value), this.countryHandler()
	},
	initProvince: function() {
		var value = this.provinceEl.getAttribute("data-default");
		value && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, value)
	},
	countryHandler: function(e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex],
			raw = opt.getAttribute("data-provinces"),
			provinces = JSON.parse(raw);
		if (this.clearOptions(this.provinceEl), provinces && provinces.length == 0) this.provinceContainer.style.display = "none";
		else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement("option");
				opt.value = provinces[i][0], opt.innerHTML = provinces[i][1], this.provinceEl.appendChild(opt)
			}
			this.provinceContainer.style.display = ""
		}
	},
	clearOptions: function(selector) {
		for (; selector.firstChild;) selector.removeChild(selector.firstChild)
	},
	setOptions: function(selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement("option");
			opt.value = values[i], opt.innerHTML = values[i], selector.appendChild(opt)
		}
	}
};
class MenuDrawer extends HTMLElement {
	constructor() {
		super(), this.mainDetailsToggle = this.querySelector("details"), navigator.platform === "iPhone" && document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`), this.addEventListener("keyup", this.onKeyUp.bind(this)), this.addEventListener("focusout", this.onFocusOut.bind(this)), this.bindEvents()
	}
	bindEvents() {
		this.querySelectorAll("summary").forEach(summary => summary.addEventListener("click", this.onSummaryClick.bind(this))), this.querySelectorAll("button").forEach(button => button.addEventListener("click", this.onCloseButtonClick.bind(this)))
	}
	onKeyUp(event) {
		if (event.code.toUpperCase() !== "ESCAPE") return;
		const openDetailsElement = event.target.closest("details[open]");
		openDetailsElement && (openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(openDetailsElement))
	}
	onSummaryClick(event) {
		const summaryElement = event.currentTarget,
			detailsElement = summaryElement.parentNode,
			parentMenuElement = detailsElement.closest(".has-submenu"),
			isOpen = detailsElement.hasAttribute("open"),
			reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

		function addTrapFocus() {
			trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector("button")), summaryElement.nextElementSibling.removeEventListener("transitionend", addTrapFocus)
		}
		detailsElement === this.mainDetailsToggle ? (isOpen && event.preventDefault(), isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement)) : setTimeout(() => {
			detailsElement.classList.add("menu-opening"), summaryElement.setAttribute("aria-expanded", !0), parentMenuElement && parentMenuElement.classList.add("submenu-open"), !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener("transitionend", addTrapFocus)
		}, 100)
	}
	openMenuDrawer(summaryElement) {
		setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening")
		}), summaryElement.setAttribute("aria-expanded", !0), trapFocus(this.mainDetailsToggle, summaryElement), document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
	}
	closeMenuDrawer(event, elementToFocus = !1) {
		event !== void 0 && (this.mainDetailsToggle.classList.remove("menu-opening"), this.mainDetailsToggle.classList.contains("mobile-facets__disclosure") || this.mainDetailsToggle.querySelectorAll("details").forEach(details => {
			details.removeAttribute("open"), details.classList.remove("menu-opening")
		}), this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach(submenu => {
			submenu.classList.remove("submenu-open")
		}), document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`), removeTrapFocus(elementToFocus), this.closeAnimation(this.mainDetailsToggle))
	}
	onFocusOut(event) {
		setTimeout(() => {
			this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement) && this.closeMenuDrawer()
		})
	}
	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest("details");
		this.closeSubmenu(detailsElement)
	}
	closeSubmenu(detailsElement) {
		const parentMenuElement = detailsElement.closest(".submenu-open");
		parentMenuElement && parentMenuElement.classList.remove("submenu-open"), detailsElement.classList.remove("menu-opening"), detailsElement.querySelector("summary").setAttribute("aria-expanded", !1), removeTrapFocus(detailsElement.querySelector("summary")), this.closeAnimation(detailsElement)
	}
	closeAnimation(detailsElement) {
		let animationStart;
		const handleAnimation = time => {
			animationStart === void 0 && (animationStart = time), time - animationStart < 400 ? window.requestAnimationFrame(handleAnimation) : (detailsElement.removeAttribute("open"), detailsElement.closest("details[open]") && trapFocus(detailsElement.closest("details[open]"), detailsElement.querySelector("summary")))
		};
		window.requestAnimationFrame(handleAnimation)
	}
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
	constructor() {
		super()
	}
	openMenuDrawer(summaryElement) {
		this.header = this.header || document.getElementById("shopify-section-header"), this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0, document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom-this.borderOffset)}px`), this.header.classList.add("menu-open"), setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening")
		}), summaryElement.setAttribute("aria-expanded", !0), trapFocus(this.mainDetailsToggle, summaryElement), document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
	}
	closeMenuDrawer(event, elementToFocus) {
		super.closeMenuDrawer(event, elementToFocus), this.header.classList.remove("menu-open")
	}
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
	constructor() {
		super(), this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, !1)), this.addEventListener("keyup", event => {
			event.code.toUpperCase() === "ESCAPE" && this.hide()
		}), this.classList.contains("media-modal") ? this.addEventListener("pointerup", event => {
			event.pointerType === "mouse" && !event.target.closest("deferred-media, product-model") && this.hide()
		}) : this.addEventListener("click", event => {
			event.target === this && this.hide()
		})
	}
	connectedCallback() {
		this.moved || (this.moved = !0, document.body.appendChild(this))
	}
	show(opener) {
		this.openedBy = opener;
		const popup = this.querySelector(".template-popup");
		document.body.classList.add("overflow-hidden"), this.setAttribute("open", ""), popup && popup.loadContent(), trapFocus(this, this.querySelector('[role="dialog"]')), window.pauseAllMedia()
	}
	hide() {
		document.body.classList.remove("overflow-hidden"), document.body.dispatchEvent(new CustomEvent("modalClosed")), this.removeAttribute("open"), removeTrapFocus(this.openedBy), window.pauseAllMedia();
    const klaviyoBis = this.querySelector('klaviyo-bis');
    if (klaviyoBis) {
      this.handleKlaviyoBisClose(klaviyoBis);
    }
	}
  handleKlaviyoBisClose(klaviyoBis) {
    klaviyoBis.querySelector(".bis-main").classList.remove("hidden");
  }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
	constructor() {
		super();
		const button = this.querySelector("button");
		button && button.addEventListener("click", () => {
			const modal = document.querySelector(this.getAttribute("data-modal"));
			modal && modal.show(button)
		})
	}
}
customElements.define("modal-opener", ModalOpener);
class ModalCloser extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("click", () => {
			const modal = this.closest("modal-dialog");
			modal && modal.hide()
		})
	}
}
customElements.define("modal-closer", ModalCloser);
class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		const poster = this.querySelector('[id^="Deferred-Poster-"]');
		poster && (poster.classList.contains("no_poster") ? (this.checkIfVideoInView = this.checkIfVideoInView.bind(this), document.addEventListener("scroll", this.checkIfVideoInView)) : poster.addEventListener("click", this.loadContent.bind(this)))
	}
	checkIfVideoInView() {
		const posterBoundingClientRect = this.querySelector('[id^="Deferred-Poster-"]').getBoundingClientRect(),
			top = posterBoundingClientRect.top - 50,
			bottom = posterBoundingClientRect.bottom + 50;
		top <= window.innerHeight && bottom >= 0 && (this.loadContent(), this.removeVideoListener())
	}
	removeVideoListener(el) {
		document.removeEventListener("scroll", this.checkIfVideoInView)
	}
	loadContent() {
		if (window.pauseAllMedia(), !this.getAttribute("loaded")) {
			const content = document.createElement("div");
			content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)), this.setAttribute("loaded", !0), this.appendChild(content.querySelector("video, model-viewer, iframe")).focus();
			const ad = this.closest(".card-wrapper__ad");
			if (!ad) return;
			ad.classList.add("video-loaded")
		}
	}
}
customElements.define("deferred-media", DeferredMedia);
class SliderComponent extends HTMLElement {
	constructor() {
		if (super(), this.slider = this.querySelector('[id^="Slider-"]'), this.sliderItems = this.querySelectorAll('[id^="Slide-"]'), this.enableSliderLooping = !1, this.currentPageElement = this.querySelector(".slider-counter--current"), this.pageTotalElement = this.querySelector(".slider-counter--totals"), this.prevButton = this.querySelector('button[name="previous"]'), this.nextButton = this.querySelector('button[name="next"]'), !this.slider || !this.nextButton) return;
		this.initPages(), new ResizeObserver(entries => this.initPages()).observe(this.slider), this.slider.addEventListener("scroll", this.update.bind(this)), this.prevButton.addEventListener("click", this.onButtonClick.bind(this)), this.nextButton.addEventListener("click", this.onButtonClick.bind(this))
	}
	initPages() {
		this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0), !(this.sliderItemsToShow.length < 2) && (this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft, this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset), this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1, this.update())
	}
	resetPages() {
		this.sliderItems = this.querySelectorAll('[id^="Slide-"]'), this.initPages()
	}
	update() {
		if (!this.slider || !this.nextButton) return;
		const previousPage = this.currentPage;
		this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1, this.currentPageElement && this.pageTotalElement && (this.currentPageElement.textContent = this.currentPage, this.pageTotalElement.textContent = this.totalPages), this.currentPage != previousPage && this.dispatchEvent(new CustomEvent("slideChanged", {
			detail: {
				currentPage: this.currentPage,
				currentElement: this.sliderItemsToShow[this.currentPage - 1]
			}
		})), !this.enableSliderLooping && (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0 ? this.prevButton.setAttribute("disabled", "disabled") : this.prevButton.removeAttribute("disabled"), this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1]) ? this.nextButton.setAttribute("disabled", "disabled") : this.nextButton.removeAttribute("disabled"))
	}
	isSlideVisible(element, offset = 0) {
		const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
		return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft
	}
	onButtonClick(event) {
		event.preventDefault();
		const step = event.currentTarget.dataset.step || 1;
		this.slideScrollPosition = event.currentTarget.name === "next" ? this.slider.scrollLeft + step * this.sliderItemOffset : this.slider.scrollLeft - step * this.sliderItemOffset, this.slider.scrollTo({
			left: this.slideScrollPosition
		})
	}
}
customElements.define("slider-component", SliderComponent);
class SlideshowComponent extends SliderComponent {
	constructor() {
		super(), this.sliderControlWrapper = this.querySelector(".slider-buttons"), this.enableSliderLooping = !0, this.sliderControlWrapper && (this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide"), this.sliderItemsToShow.length > 0 && (this.currentPage = 1), this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link")), this.sliderControlLinksArray.forEach(link => link.addEventListener("click", this.linkToSlide.bind(this))), this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this)), this.setSlideVisibility(), this.slider.getAttribute("data-autoplay") === "true" && this.setAutoPlay())
	}
	setAutoPlay() {
		this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay"), this.autoplaySpeed = this.slider.dataset.speed * 1e3, this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this)), this.addEventListener("mouseover", this.focusInHandling.bind(this)), this.addEventListener("mouseleave", this.focusOutHandling.bind(this)), this.addEventListener("focusin", this.focusInHandling.bind(this)), this.addEventListener("focusout", this.focusOutHandling.bind(this)), this.play(), this.autoplayButtonIsSetToPlay = !0
	}
	onButtonClick(event) {
		super.onButtonClick(event);
		const isFirstSlide = this.currentPage === 1,
			isLastSlide = this.currentPage === this.sliderItemsToShow.length;
		!isFirstSlide && !isLastSlide || (isFirstSlide && event.currentTarget.name === "previous" ? this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length : isLastSlide && event.currentTarget.name === "next" && (this.slideScrollPosition = 0), this.slider.scrollTo({
			left: this.slideScrollPosition
		}))
	}
	update() {
		super.update(), this.sliderControlButtons = this.querySelectorAll(".slider-counter__link"), this.prevButton.removeAttribute("disabled"), this.sliderControlButtons.length && (this.sliderControlButtons.forEach(link => {
			link.classList.remove("slider-counter__link--active"), link.removeAttribute("aria-current")
		}), this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active"), this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", !0))
	}
	autoPlayToggle() {
		this.togglePlayButtonState(this.autoplayButtonIsSetToPlay), this.autoplayButtonIsSetToPlay ? this.pause() : this.play(), this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay
	}
	focusOutHandling(event) {
		const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
		!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton || this.play()
	}
	focusInHandling(event) {
		(event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target)) && this.autoplayButtonIsSetToPlay ? this.play() : this.autoplayButtonIsSetToPlay && this.pause()
	}
	play() {
		this.slider.setAttribute("aria-live", "off"), clearInterval(this.autoplay), this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed)
	}
	pause() {
		this.slider.setAttribute("aria-live", "polite"), clearInterval(this.autoplay)
	}
	togglePlayButtonState(pauseAutoplay) {
		pauseAutoplay ? (this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused"), this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow)) : (this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused"), this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow))
	}
	autoRotateSlides() {
		const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector(".slideshow__slide").clientWidth;
		this.slider.scrollTo({
			left: slideScrollPosition
		})
	}
	setSlideVisibility() {
		this.sliderItemsToShow.forEach((item, index) => {
			const linkElements = item.querySelectorAll("a");
			index === this.currentPage - 1 ? (linkElements.length && linkElements.forEach(button => {
				button.removeAttribute("tabindex")
			}), item.setAttribute("aria-hidden", "false"), item.removeAttribute("tabindex")) : (linkElements.length && linkElements.forEach(button => {
				button.setAttribute("tabindex", "-1")
			}), item.setAttribute("aria-hidden", "true"), item.setAttribute("tabindex", "-1"))
		})
	}
	linkToSlide(event) {
		event.preventDefault();
		const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
		this.slider.scrollTo({
			left: slideScrollPosition
		})
	}
}
customElements.define("slideshow-component", SlideshowComponent);

function onlyUnique(value, index, array) {
	return array.indexOf(value) === index
}

function returnArrayMinusObject(array, object) {
	const filteredArray = [];
	return array.forEach(element => {
		element !== object && filteredArray.push(element)
	}), filteredArray
}
class VariantSelects extends HTMLElement {
	constructor() {
		super(), this.addEventListener("change", this.onVariantChange)
	}
	onVariantChange() {
		this.checkData(), 
          this.updateOptions(), 
          this.updateMasterId(), 
          this.toggleAddButton(!0, "", !1), 
          this.updatePickupAvailability(), 
          this.removeErrorMessage(), 
          this.updateDoesNotExist(), 
          this.updateFieldsetText(), 
          this.updateSale(), 
          this.currentVariant ? (
           // this.updateSoldOut(), 
            this.backInStockCheck(), 
            this.updateMedia(), 
            this.updateFeaturedMedia(), 
            this.updateURL(), 
            this.updateVariantInput(), 
            this.renderProductInfo(), 
            this.updateShareUrl(), 
            this.regionalInventory(), 
            this.crossEmOut(), 
            this.missingVar()) : (this.toggleAddButton(!0, "", !0), this.setUnavailable(), this.regionalInventory(), this.crossEmOut(), this.missingVar())
	}
	getBackInStockData(data) {
		return this.bisData = this.bisData || JSON.parse(data.textContent), this.bisData
	}
	backInStockCheck() {
		const bisJSON = document.getElementById(`bis-disabled-${this.dataset.section}`),
			bisJSONvariant = this.getBackInStockData(bisJSON).find(x => x.id === this.currentVariant.id),
			bisEl = document.getElementById(`BackInStockModal-${this.dataset.section}`);
		if (this.showBIS = !1, !this.currentVariant || !bisJSON || (this.showBIS = !bisJSONvariant.disabled, !bisEl)) return;
		const titleArray = this.currentVariant.name.split(" - ");
		bisEl.querySelector("h5").innerText = window.backInStock.modal.replace("[PRODUCT]", titleArray[0].trim()).replace("[VARIANT]", titleArray[1].trim())
	}
	regionalInventory() {
		const $this = this;
		setTimeout(function() {
			console.log("regional inventory");
			var vid = $('.product-form form input[name="id"]').val(),
				on = $(".regon").val(),
				region = $(".region").val(),
				usinv = parseInt($('.rinv[data-vid="' + vid + '"]').data("usinv"), 10),
				cainv = parseInt($('.rinv[data-vid="' + vid + '"]').data("cainv"), 10),
				secretsale = parseInt($('.rinv[data-vid="' + vid + '"]').data("ss"), 10),
				bis = $('.rinv[data-vid="' + vid + '"]').data("showbis");
			const productForm = document.getElementById(`product-form-${$this.dataset.section}`).closest("product-form"),
				productFormSubmit = productForm.querySelector(".product-form__submit"),
				backInStockSubmit = productForm.querySelector(".product-form__bis.button");
			var backInStockVisible = !1;
			console.log("ss:" + secretsale), $("input#secretsale").remove(), secretsale > 0 && secretsale != null && $("product-form form").append('<input id="secretsale" type="hidden" name="properties[_secretsale]" value="' + secretsale + '">'), usinv < 1 ? $("#usinvf").val(0) : $("#usinvf").val(usinv), cainv < 1 ? $("#cainvf").val(0) : $("#cainvf").val(cainv), on == "true" && (region == "us" ? usinv > 0 ? ($(".product-form__buttons .product-form__submit.button").prop("disabled", !1).find("span").text("Add To Cart"), usinv > 5 ? $(".threshold-message").hide() : $(".threshold-message").show().text("Only " + usinv + " Left")) : ($(".product-form__buttons .product-form__submit.button").prop("disabled", !0).find("span").text("Out of Stock"), $(".threshold-message").hide(), backInStockVisible = !0) : cainv > 0 ? ($(".product-form__buttons .product-form__submit.button").prop("disabled", !1).find("span").text("Add To Cart"), cainv > 5 ? $(".threshold-message").hide() : $(".threshold-message").show().text("Only " + cainv + " Left")) : ($(".product-form__buttons .product-form__submit.button").prop("disabled", !0).find("span").text("Out of Stock"), $(".threshold-message").hide(), backInStockVisible = !0)), console.log("usinv", usinv), console.log("bis", bis), console.log("backInStockVisible", backInStockVisible), backInStockSubmit && (backInStockVisible && bis ? (productFormSubmit.classList.add("hide"), backInStockSubmit.classList.remove("hide")) : (productFormSubmit.classList.remove("hide"), backInStockSubmit.classList.add("hide")))
console.log("inve checker usinv:"+usinv+" cainv:"+cainv);

 if($("product-form form #usinvf").length == 0){    
 $("product-form form").append('<input id="usinvf" type="hidden" name="properties[_usinv]" value="' + usinv + '">');
 }

if($("product-form form #cainvf").length == 0){    
 $("product-form form").append('<input id="cainvf" type="hidden" name="properties[_cainv]" value="' + cainv + '">');
}
          
if(secretsale > 0 && secretsale != null){
  $("product-form form").append('<input id="secretsale" type="hidden" name="properties[_secretsale]" value="' + secretsale + '">');
} else{
  $("input#secretsale").remove();
}

if (document.getElementById('secretsale')) {
  $('#secretsale').each(function(){
    $(this).val(secretsale);
  });
}

$("product-form form").find('#usinvf').val(usinv);
$("product-form form").find('#cainvf').val(cainv); 
                   
          if(backInStockVisible == true ){
              if(bis == false){
                $(".product-form__bis.button").hide();$(".product-form__submit").show();
              }else{
              $(".product-form__bis.button").show();$(".product-form__submit").hide();
              }}else{$(".product-form__bis.button").hide();$(".product-form__submit").show();}
		}, 20)
	}
	missingVar() {
    // OLD missing var that wasn't working.  
	//	console.log("checking if this var even exists");
	//	var op1 = $(".product-form__input-color input:checked").val(),
	//		op2 = $(".product-form__input-size input:checked").val(),
	//		op3 = $(".product-form__input-length input:checked").val(),
	//		vid = $('.rinv[data-op1="' + op1 + '"][data-op2="' + op2 + '"][data-op3="' + op3 + '"]').data("vid");
	//	console.log(vid), vid ? console.log("found") : op3 && (setTimeout(function() {
	//		$(".product-form__buttons .product-form__submit.button").prop("disabled", !0).find("span").text("Out of Stock"), console.log("none")
	//	}, 10), setTimeout(function() {
	//		$(".product-form__buttons .product-form__submit.button").prop("disabled", !0).find("span").text("Out of Stock"), console.log("none")
	//	}, 200), setTimeout(function() {
	//		$(".product-form__buttons .product-form__submit.button").prop("disabled", !0).find("span").text("Out of Stock"), console.log("none")
	//	}, 500))
      
        // Get selected options
        var op1 = $(".product-form__input-color input:checked").val();
        console.log("op1 (color):", op1, "Element exists:", $(".product-form__input-color input:checked").length > 0);
        
        var op2 = $(".product-form__input-size input:checked").val();
        console.log("op2 (size):", op2, "Element exists:", $(".product-form__input-size input:checked").length > 0);
        
        // Check if length selector exists at all
        var lengthSelectorExists = $(".product-form__input-length").length > 0;
        console.log("Length selector exists on page:", lengthSelectorExists);
        
        var op3 = $(".product-form__input-length input:checked").val() || "";
        console.log("op3 (length):", op3, "Element exists:", $(".product-form__input-length input:checked").length > 0);
        
        // Build the correct selector
        var selector = '.rinv';
        if (op1) selector += '[data-op1="' + op1 + '"]';
        if (op2) selector += '[data-op2="' + op2 + '"]';
        // Only add op3 to selector if length option exists on the page
        if (lengthSelectorExists) {
            selector += '[data-op3="' + op3 + '"]';
        }
        
        console.log("Looking for variant with selector:", selector);
        console.log("Matching elements found:", $(selector).length);
        
        var vid = $(selector).data("vid");
        console.log("vid value:", vid);
        
        // If no variant is found, disable the button
        if (vid) {
            console.log("Found variant, button should remain enabled");
        } else {
            console.log("No variant found, should disable button");
            
            var disableButton = function() {
                var $button = $(".product-form__buttons .product-form__submit.button");
                console.log("Button found:", $button.length > 0);
                $button.prop("disabled", true).find("span").text("Out of Stock");
                //console.log("Button disabled state:", $button.prop("disabled"));
                //console.log("none");
            };
            
            // Try multiple times with different delays
            setTimeout(disableButton, 10);
            setTimeout(disableButton, 200);
            setTimeout(disableButton, 500);
        }
      
	}

  
	crossEmOut() {
		var nums = 0;
		if ($(".product__info-container .sidebar__inner-padding > fieldset").each(function() {
				nums = nums + 1
			}), console.log("nums:" + nums), nums < 3) {
			var op1 = $(".product-form__input-color input:checked").val();
			$(".product-form__input-size input").each(function() {
				var op2 = $(this).val(),
					region = $(".region").val();
				if (region == "us") {
					var invnum = parseInt($('.rinv[data-op1="' + op1 + '"][data-op2="' + op2 + '"]').data("usinv"), 10);
					if (invnum < 1 || isNaN(invnum)) {
						var idd = $('.sidebar__inner-padding .product-form__input-size input[value="' + op2 + '"]').attr("id");
						$('.sidebar__inner-padding .product-form__input-size label[for="' + idd + '"]').addClass("oos")
					} else {
						var idd = $('.sidebar__inner-padding .product-form__input-size input[value="' + op2 + '"]').attr("id");
						$('.sidebar__inner-padding .product-form__input-size label[for="' + idd + '"]').removeClass("oos")
					}
				} else {
					var invnum = parseInt($('.rinv[data-op1="' + op1 + '"][data-op2="' + op2 + '"]').data("cainv"), 10);
					if (invnum < 1 || isNaN(invnum)) {
						var idd = $('.sidebar__inner-padding .product-form__input-size input[value="' + op2 + '"]').attr("id");
						$('.sidebar__inner-padding .product-form__input-size label[for="' + idd + '"]').addClass("oos")
					} else {
						var idd = $('.sidebar__inner-padding .product-form__input-size input[value="' + op2 + '"]').attr("id");
						$('.sidebar__inner-padding .product-form__input-size label[for="' + idd + '"]').removeClass("oos")
					}
				}
			})
		}
	}
	updateSale() {
		setTimeout(function() {
			console.log("$(this)", $(this)), console.log("new price switcher global");
			var vid = $('.product-form form input[name="id"]').val(),
				price = $('.rinv[data-vid="' + vid + '"]').data("price"),
				cap = $('.rinv[data-vid="' + vid + '"]').data("cap"),
				pprice = parseInt($('.rinv[data-vid="' + vid + '"]').data("pprice"), 10),
				pfar = $('.rinv[data-vid="' + vid + '"]').data("pfa"),
				pcap = parseInt($('.rinv[data-vid="' + vid + '"]').data("pcap"), 10),
				po = parseInt((pcap - pprice) / pcap * 100);
			console.log("po: " + po + " vid: " + vid + " pfar:" + pfar), pfar == !1 || pfar == "false" ? $("#pfas").show() : $("#pfas").hide(), $(".sidebar__inner .price-item.price-item--regular").text(price), vid != "" && (cap != "" ? ($(".price__sale").css("display", "inline-block"), $(".price__sale .price-item--last").css("display", "inline-block").css("text-decoration", "line-through").text(cap), $(".percentoff").css("display", "inline-block").find(".poo").text(po)) : ($(".price__sale").css("display", "none"), $(".price__sale .price-item--last").css("display", "none").text(""), $(".percentoff").css("display", "none")))
		}, 500)
	}
	checkData() {
		this.parentProduct = this.hasAttribute("data-parent"), this.optionBase = this.dataset.base.split(",").length
	}
	updateOptions() {
		this.options = Array.from(this.querySelectorAll("select"), select => select.value), this.optionNames = Array.from(this.querySelectorAll("select"), select => select.name)
	}
	updateMasterId() {
		this.currentVariant = this.getVariantData().find(variant => !variant.options.map((option, index) => this.options[index] === option).includes(!1))
	}
	updateMedia() {
		if (!this.currentVariant || !this.currentVariant.featured_media && !this.parentProduct) return;
		const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`),
			mediaViewer = mediaGallery.querySelector('[id^="GalleryViewer"]'),
			dataConnect = this.options.slice(0, this.optionBase).join(" / "),
			optionSpecificMedia = mediaViewer.querySelectorAll(`[data-connect="${dataConnect}"]:not([data-feature="true"])`);
		if (optionSpecificMedia.length > 0) mediaViewer.querySelectorAll("[data-connect]").forEach(element => {
			element.classList.remove("product__media-item--variant_current")
		}), optionSpecificMedia.forEach(element => {
			element.classList.add("product__media-item--variant_current")
		});
		else {
			mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, !0);
			const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
			if (!modalContent) return;
			const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
			modalContent.prepend(newMediaModal)
		}
		mediaViewer.initPages()
	}
	updateFeaturedMedia() {
		if (!this.currentVariant) return;
		const featureImages = document.querySelector("features-images");
		if (!featureImages) return;
		const galleryEl = featureImages.querySelector('[id^="GalleryViewer"]'),
			slideshowEl = featureImages.querySelector('[id^="Slider-Gallery-"]'),
			mediaViewer = document.getElementById(`MediaGallery-${this.dataset.section}`).querySelector('[id^="GalleryViewer"]'),
			dataConnect = this.options.slice(0, this.optionBase).join(" / "),
			featureSpecificMedia = mediaViewer.querySelectorAll(`[data-connect="${dataConnect}"][data-feature="true"]`);
		slideshowEl.innerHTML = "";
		var mediaLoop = new Promise((resolve, reject) => {
			featureSpecificMedia.forEach((element, index, array) => {
				let clonedImage = element.querySelector(".product__media").cloneNode(!0),
					wrapper = document.createElement("li");
				wrapper.classList.add("product__modal-opener--image", "slider__slide"), wrapper.appendChild(clonedImage), slideshowEl.appendChild(wrapper), index === array.length - 1 && resolve()
			})
		});
		featureSpecificMedia.length > 0 && mediaLoop.then(() => {})
	}
	updateURL() {
		!this.currentVariant || this.dataset.updateUrl === "false" || window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`)
	}
	updateShareUrl() {
		const shareButton = document.getElementById(`Share-${this.dataset.section}`);
		!shareButton || !shareButton.updateUrl || shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`)
	}
	updateSoldOut() {
		const optionElements = Array.from(this.querySelectorAll("fieldset"));
		if (!optionElements) return;
		const regionalInventoryEnable = document.getElementById(`regional-inventory-enable-${this.dataset.section}`);
		this.optionValues = optionElements.map(el => el.tagName === "SELECT" ? el.value : Array.from(el.querySelectorAll("input")).find(radio => radio.checked).value), this.firstOptionValue = this.firstOptionValue || this.optionValues[0];
		for (var i = 1; i < optionElements.length; i++)
			for (var optionInputs = optionElements[i].querySelectorAll("input"), j = 0; j < optionInputs.length; j++) optionInputs[j].classList.add("disabled");
		this.options.forEach((option, index) => {
			var curr_option = option,
				curr_option_index = "option" + (index + 1),
				matching_variants = this.getVariantData().filter(function(element, index2) {
					return element[curr_option_index] == curr_option
				});
			const optionPossibleValues = returnArrayMinusObject(this.options, option);
			this.getVariantData().forEach(variant => {
				let setOfOptions = new Set(variant.options);
				if (optionPossibleValues.every(option2 => setOfOptions.has(option2))) {
					var variantInventory = 100;
					if (regionalInventoryEnable && regionalInventoryEnable.value === "true") {
						const regionalIso = document.getElementById(`region-iso-${this.dataset.section}`).value,
							regionalInventoryVariantDataset = document.getElementById(`region-inventory-data-${this.dataset.section}`).querySelector(`.rinv[data-vid="${variant.id}"]`).dataset;
						variantInventory = parseInt(regionalInventoryVariantDataset[`${regionalIso}inv`])
					}
					variant.available && variantInventory > 0 && variant.options.forEach((optionValue, optionIndex) => {
						this.optionNames[optionIndex] !== "Color" && optionElements[optionIndex].querySelector(`input[value="${optionValue}"]`).classList.remove("disabled")
					})
				}
			})
		})
	}
	updateDoesNotExist() {
		for (let i = 1; i < 7; i++) {
			const optionFieldset = this.querySelector(`fieldset[data-option="option${i}"]`);
			if (optionFieldset) {
				const optionInputs = optionFieldset.querySelectorAll("input");
				for (let j = 0; j < optionInputs.length; j++) optionInputs[j].classList.remove("disabled")
			}
		}
		this.options.forEach((option, index) => {
			const matchingVariants = this.getVariantData().filter(function(element, elementIndex) {
				return element[`option${index+1}`] == option
			});
			for (let k = 1; k < 7; k++) {
				if (k - 1 === index) continue;
				const optionFieldsetCheck = this.querySelector(`fieldset[data-option="option${k}"]`);
				if (this.optionNames[k - 1] === "Color") continue;
				if (!optionFieldsetCheck) return;
				const matchingVariantsUnique = matchingVariants.map(a => a[`option${k}`]).filter(onlyUnique);
				this.variantExistsCheck(optionFieldsetCheck.querySelectorAll("input"), matchingVariantsUnique)
			}
		})
	}
	variantExistsCheck(inputs, options) {
		for (var i = 0; i < inputs.length; i++) options.includes(inputs[i].value) || inputs[i].classList.add("disabled")
	}
updateFieldsetText() {
    const currOptions = this.options;

    this.querySelectorAll("fieldset").forEach((fieldset, index) => {
        const colorGroupLegends = fieldset.querySelectorAll("legend.colorgroups");

        if (colorGroupLegends.length === 2) {
            const checkedInput = fieldset.querySelector("input:checked");

            if (checkedInput) {
                // Get the legends as an array
                const legends = Array.from(colorGroupLegends);
                
                // Find the legend that appears before the checked input in the DOM
                // by comparing their positions in the document
                const closestLegend = legends.reduce((closest, current) => {
                    // Check if the current legend is before the checked input in the DOM
                    const isCurrentBeforeInput = current.compareDocumentPosition(checkedInput) & Node.DOCUMENT_POSITION_FOLLOWING;
                    const isClosestBeforeInput = closest.compareDocumentPosition(checkedInput) & Node.DOCUMENT_POSITION_FOLLOWING;
                    
                    // If both are before the input, choose the one that's closer to the input in the DOM
                    if (isCurrentBeforeInput && isClosestBeforeInput) {
                        // If current is after closest in the DOM, it's closer to the input
                        return (current.compareDocumentPosition(closest) & Node.DOCUMENT_POSITION_PRECEDING) ? current : closest;
                    }
                    
                    // If only one is before the input, choose that one
                    return isCurrentBeforeInput ? current : closest;
                });

                const furthestLegend = legends.find(legend => legend !== closestLegend);
                const closestSpan = closestLegend.querySelector("span");
                const furthestSpan = furthestLegend.querySelector("span");

                closestSpan && (closestSpan.innerText = " - " + currOptions[index]);
                furthestSpan && (furthestSpan.innerText = "");
            }
        } else {
            const optionValue = fieldset.querySelector("legend span");
            optionValue && (optionValue.innerText = currOptions[index]);
        }
    });
}
//	updateVariantInput() {
//		document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`).forEach(productForm => {
//			const input = productForm.querySelector('input[name="id"]');
//			var notifyme = document.querySelector(".product-form__buttons").getAttribute("data-notifyme");
//			notifyme == "true" && (document.querySelector("button.pickup-store-btn").classList.add("hide"), this.currentVariant && this.currentVariant.available ? (document.querySelector("#BIS_trigger").classList.add("hide"), document.querySelector(".klarna-msg").classList.add("hide"), document.querySelector(".find-in-store").classList.add("hide"), document.querySelector("button.product-form__submit").classList.remove("hide")) : (document.querySelector(".find-in-store").classList.add("hide"), document.querySelector(".klarna-msg").classList.remove("hide"), document.querySelector("#BIS_trigger").classList.remove("hide"), document.querySelector("button.product-form__submit").classList.add("hide"))), input.value = this.currentVariant.id, input.dispatchEvent(new Event("change", {
//				bubbles: !0
//			}))
//		})
//	}

updateVariantInput() {
  // Debug mode flag - set to true to enable debug logs
  const debug = false;
  
  document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`).forEach(productForm => {
    const input = productForm.querySelector('input[name="id"]');
    const productFormButtons = document.querySelector(".product-form__buttons");
    
    if (debug) {
      console.log('Product form buttons element:', productFormButtons);
    }
    
    var notifyme = productFormButtons?.getAttribute("data-notifyme");
    
    if (debug) {
      console.log('Notifyme attribute value:', notifyme);
    }
    
    if (notifyme == "true") {
      // Get all elements we need to manipulate
      const elements = {
        pickupStoreBtn: document.querySelector("button.pickup-store-btn"),
        bisTrigger: document.querySelector("#BIS_trigger"),
        klarnaMsg: document.querySelector(".klarna-msg"),
        findInStore: document.querySelector(".find-in-store"),
        submitBtn: document.querySelector("button.product-form__submit")
      };
      
      if (debug) {
        // Log each element to see which ones are null
        console.group('DOM Elements Status:');
        Object.entries(elements).forEach(([name, element]) => {
          console.log(`${name}: ${element ? 'Found ✓' : 'NULL ✗'}`);
        });
        console.groupEnd();
        
        console.log('Current variant:', this.currentVariant);
        if (this.currentVariant) {
          console.log('Variant available:', this.currentVariant.available);
        }
      }
      
      // Add null checks before accessing classList
      elements.pickupStoreBtn?.classList.add("hide");
      
      if (this.currentVariant && this.currentVariant.available) {
        if (debug) console.log('Branch: Variant available');
        elements.bisTrigger?.classList.add("hide");
        elements.klarnaMsg?.classList.add("hide");
        elements.findInStore?.classList.add("hide");
        elements.submitBtn?.classList.remove("hide");
      } else {
        if (debug) console.log('Branch: Variant unavailable or null');
        elements.findInStore?.classList.add("hide");
        elements.klarnaMsg?.classList.remove("hide");
        elements.bisTrigger?.classList.remove("hide");
        elements.submitBtn?.classList.add("hide");
      }
    }
    
    if (input && this.currentVariant) {
      if (debug) console.log('Setting input value to:', this.currentVariant.id);
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", {
        bubbles: !0
      }));
    } else if (debug) {
      console.log('Cannot set input value:', {
        inputExists: !!input,
        currentVariantExists: !!this.currentVariant
      });
    }
  });
}
 
  
	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector("pickup-availability");
		if (pickUpAvailability)
			if (this.currentVariant && this.currentVariant.available) {
				console.log("currentVariant");
				var message = $(".threshold-message"),
					vid = this.currentVariant.id,
					wxVariant = $(".wx-variants").find("." + vid);
				if (wxVariant.length > 0) {
					var lowQuantity = parseInt(message.attr("data-low-quantity"), 10),
						variantQuantity = parseInt(wxVariant.attr("quantity"), 10);
					if (variantQuantity <= lowQuantity) {
						var newMessage = message.attr("data-message").replace("{quantity}", variantQuantity);
						message.empty(), message.append(newMessage)
					} else message.empty()
				}
				pickUpAvailability.fetchAvailability(this.currentVariant.id)
			} else {
				var message = $(".threshold-message");
				pickUpAvailability.removeAttribute("available"), pickUpAvailability.innerHTML = "", message.empty()
			}
	}
	checkImages() {
		setTimeout(function() {
			console.log("checking images");
			var size = $("slider-component li:visible").length;
			size > 2 && $("slider-component li:visible").each(function() {
				var alt = $(this).find("img").attr("alt");
				alt == "E1" || alt == "C1" || alt == ".p"
			})
		}, 20)
	}
	removeErrorMessage() {
		const section = this.closest("section");
		if (!section) return;
		const productForm = section.querySelector("product-form");
		productForm && productForm.handleErrorMessage()
	}
	renderProductInfo() {
		fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection?this.dataset.originalSection:this.dataset.section}`).then(response => response.text()).then(responseText => {
			const html = new DOMParser().parseFromString(responseText, "text/html"),
				destination = document.getElementById(`price-${this.dataset.section}`),
				source = html.getElementById(`price-${this.dataset.originalSection?this.dataset.originalSection:this.dataset.section}`),
				price = document.getElementById(`price-${this.dataset.section}`);
			price && price.classList.remove("visibility-hidden"), this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut)
		})
	}
	toggleAddButton(disable = !0, text, modifyClass = !0) {
		const productForm = document.getElementById(`product-form-${this.dataset.section}`);
		if (!productForm) return;
		const addButton = productForm.querySelector('[name="add"]'),
			addButtonText = productForm.querySelector('[name="add"] > span'),
			klaviyoBISel = productForm.querySelector("klaviyo-bis");
		addButton && (disable ? klaviyoBISel && klaviyoBISel.classList.add("hide") : klaviyoBISel && klaviyoBISel.classList.remove("hide"))
	}
	setUnavailable() {
		const button = document.getElementById(`product-form-${this.dataset.section}`),
			addButton = button.querySelector('[name="add"]'),
			addButtonText = button.querySelector('[name="add"] > span'),
			price = document.getElementById(`price-${this.dataset.section}`);
		addButton && (addButtonText.textContent = window.variantStrings.unavailable, price && price.classList.add("visibility-hidden"))
	}
	getVariantData() {
		return this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent), this.variantData
	}
	removeAllChildNodes(parent) {
		for (; parent.firstChild;) parent.removeChild(parent.firstChild)
	}
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
	constructor() {
		super()
	}
	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll("fieldset"));
		this.options = fieldsets.map(fieldset => Array.from(fieldset.querySelectorAll("input")).find(radio => radio.checked).value), this.optionNames = fieldsets.map(fieldset => Array.from(fieldset.querySelectorAll("input")).find(radio => radio.checked).name)
	}
}
customElements.define("variant-radios", VariantRadios);
class TooltipOpener extends HTMLElement {
	constructor() {
		super();
		const tooltip = new bootstrap.Tooltip(this)
	}
}
customElements.define("tooltip-component", TooltipOpener);

function serializeJSON(form, invisible = !0) {
	const formData = new FormData(form),
		pairs = {},
		consistent = {};
	if (invisible)
		for (const [name, value] of formData) value === null || value === "" || JSON.stringify(value) === "{}" || (name == "form_type" || name == "utf8" ? consistent[name] = value : pairs[name] = value);
	else {
		const visibleInputs = Array.from(form.elements).filter(e => e.style.display !== "none");
		for (var i = 0; i < visibleInputs.length; i++) visibleInputs[i].value === null || visibleInputs[i].value === "" || JSON.stringify(visibleInputs[i].value) === "{}" || (visibleInputs[i].name == "form_type" || visibleInputs[i].name == "utf8" ? consistent[visibleInputs[i].name] = visibleInputs[i].value : pairs[visibleInputs[i].name] = visibleInputs[i].value)
	}
	return JSON.stringify({
		consistent,
		data: pairs
	}, null, 2)
}
class FormBuilder extends HTMLElement {
	constructor() {
		super(), this.form = document.querySelector("#warranty-form"), this.thanks = document.querySelector("#thanks"), this.form_submit = document.getElementById("custom-form-submit"), this.steps = this.form.querySelectorAll("step-button"), this.form && (this.form.addEventListener("submit", this.formSubmit.bind(this)), this.querySelectorAll(".field__input-file").forEach(input => input.addEventListener("change", this.onFileInput.bind(this))), this.querySelectorAll('[data-autocomplete-response="true"]').forEach(input => input.addEventListener("focusout", this.autocompleteResponse.bind(this))), this.radios = this.form.querySelectorAll('input[type="radio"]'), this.radios && this.radios.forEach(radio => radio.addEventListener("change", this.conditionalCheck.bind(this))));
      this.labels = this.form.querySelectorAll('label'), this.labels && this.labels.forEach(label => label.addEventListener("click", this.labelClickCheck.bind(this)))
	}
	onFileInput(event) {
		const input = event.target,
			file_link = input.nextElementSibling;
		if (input.files) {
			this.form_submit.classList.add("button--loading"), this.form_submit.disabled = !0;
			const file = input.files[0],
				formData = new FormData;
			formData.append("file", file), formData.append("document", this.form_submit.dataset.source);
			var res = Array.from(formData.entries(), ([key, prop]) => ({
				[key]: {
					ContentLength: typeof prop == "string" ? prop.length : prop.size
				}
			}));
			console.log("file.size", file.size), file.size > 1e7 ? (alert("File size too large, please reduce file size and resubmit"), input.value = "") : (console.log("input.dataset.sendTo", input.dataset.sendTo), fetch(input.dataset.sendTo, {
				method: "POST",
				body: formData
			}).then(response => response.text()).then(data => {
				file_link.value = data, this.form_submit.classList.remove("button--loading"), document.getElementById("custom-form-submit").disabled = !1
			}).catch(error => {
				this.form_submit.classList.remove("button--loading"), document.getElementById("custom-form-submit").disabled = !1
			}))
		}
	}
	autocompleteResponse(event) {
		!this.dataset.autocheck || !this.steps || fetch(this.dataset.autocheck, {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: serializeJSON(this.form)
		}).then(response => response.json()).then(data => {
			if (data.autoapprove) {
				const fileUploadStepData = this.querySelector('[data-file-upload="true"]').dataset;
				this.steps.forEach(step => {
					const stepGoTo = step.getAttribute("data-step-goto");
					console.log("step", step), console.log("step.dataset.step", step.dataset.step), console.log("stepGoTo", stepGoTo), console.log("fileUploadStepData.stepNo", fileUploadStepData.stepNo), stepGoTo == fileUploadStepData.stepNo && (step.dataset.step == "back" ? step.setAttribute("data-step-goto", parseInt(fileUploadStepData.stepNo) - 1) : step.setAttribute("data-step-goto", parseInt(fileUploadStepData.stepNo) + 1))
				}), console.log("fileUploadStepData", fileUploadStepData)
			}
		}).catch(error => {
			console.error("Error:", error)
		})
	}
	conditionalCheck(event) {
		const currentConditionals = event.target.closest("fieldset").querySelectorAll('input[type="radio"]');
		if (Array.from(currentConditionals).forEach(radio => {
				"conditionalConnected" in radio.dataset && this.querySelector(`[data-connected="${radio.dataset.conditionalConnected}"]`) && this.querySelector(`[data-connected="${radio.dataset.conditionalConnected}"]`).classList.add("hidden")
			}), !event.target.dataset.conditionalConnected) return;
		const conditionalEl = this.querySelector(`[data-connected="${event.target.dataset.conditionalConnected}"]`);
		conditionalEl && conditionalEl.classList.remove("hidden")
	}
	formSubmit(event) {
		event.preventDefault(), console.log("this.dataset.send", this.dataset.send), console.log("serializeJSON(this.form)", serializeJSON(this.form)), this.form_submit.classList.add("animate");
		let redirect_url;
		this.hasAttribute("data-redirect") && (redirect_url = this.dataset.redirect), fetch(this.dataset.send, {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: serializeJSON(this.form)
		}).then(response => response.json()).then(data => {
			this.form_submit.classList.remove("animate"), this.form_submit.classList.add("success"), setTimeout(function() {
				if (data.hasOwnProperty("success")) this.form.classList.add("hidden"), this.thanks.classList.remove("hidden"), this.thanks.scrollIntoView(), redirect_url ? setTimeout(function() {
					window.location.href = redirect_url
				}, 500) : data.success == "domain" ? this.thanks.querySelector(".domain").classList.remove("hidden") : data.success == "procode" ? this.thanks.querySelector(".procode").classList.remove("hidden") : this.thanks.querySelector(".default").classList.remove("hidden");
				else {
					var form_error = document.getElementById("form_error");
					form_error || (form_error = document.createElement("div"), form_error.id = "form_error", this.form_submit.parentNode.insertBefore(form_error, this.form_submit.nextSibling)), form_error.innerText = data.error
				}
			}.bind(this), 500)
		}).catch(error => {
			console.error("Error:", error), this.form_submit.classList.remove("animate"), this.form_submit.classList.add("error")
		})
	}
  labelClickCheck(event) {
    console.log('event.target',event.target);
  }
}
customElements.define("form-builder", FormBuilder);
class ApplyProcode extends HTMLElement {
	constructor() {
		super(), this.procodeForm = document.getElementById("pro-code--form"), this.container = document.getElementById("procode"), this.thanks = document.getElementById("pro-code--thanks"), this.procodeForm.addEventListener("submit", this.procodeCheck.bind(this))
	}
	procodeCheck(event) {
		event.preventDefault();
		const form = event.target,
			form_submit = form.querySelector("button");
		let redirect_url;
		this.hasAttribute("data-redirect") && (redirect_url = this.dataset.redirect), form_submit.disabled = !0, form_submit.classList.add("button--loading"), fetch("https://hook.us1.make.com/95l6jr5qki6y4c8rxlys1yrai2o7dw47", {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: serializeJSON(form)
		}).then(response => response.json()).then(data => {
			form_submit.disabled = !1, form_submit.classList.remove("button--loading");
			var form_error = document.getElementById("form_error");
			form_error || (form_error = document.createElement("div"), form_error.id = "form_error", form_submit.parentNode.insertBefore(form_error, form_submit.nextSibling)), data.success ? (this.form.classList.add("hidden"), this.thanks.classList.remove("hidden"), this.thanks.scrollIntoView(), redirect_url && setTimeout(function() {
				window.location.href = redirect_url
			}, 500)) : form_error.innerText = data.reason
		}).catch(error => {
			console.error("Error:", error)
		})
	}
}
customElements.define("apply-procode", ApplyProcode), String.prototype.imgURL = function(size) {
	return this.replace(/\.jpg|\.png|\.gif|\.jpeg/g, function(match) {
		return "_" + size + match
	})
};
/*
 * @license Basictable - Vanilla JS | MIT | Jerry Low | https://www.github.com/jerrylow/basictable
 */
class basictable {
	constructor(t, e = {}) {
		this.tableSel = t, this.options = {
			breakpoint: null,
			containerBreakpoint: null,
			contentWrap: !0,
			forceResponsive: !0,
			noResize: !1,
			tableWrap: !1,
			showEmptyCells: !1,
			header: !0,
			...e
		}, this.options.breakpoint === null && this.options.containerBreakpoint === null && (this.options.breakpoint = 568), this._getTables(), this._setup()
	}
	_getTables() {
		this.tables = document.querySelectorAll(this.tableSel)
	}
	_setup() {
		this.tables.forEach(t => {
			t.setAttribute("data-bt-active", !0);
			const e = [];
			if (this.options.tableWrap) {
				const e2 = document.createElement("div");
				e2.classList.add("bt-wrapper"), t.parentNode.insertBefore(e2, t), e2.appendChild(t)
			}
			if (this.options.header) {
				let s = "";
				s = t.querySelectorAll("thead tr th").length ? "thead th" : t.querySelectorAll("tbody tr th").length ? "tbody tr th" : t.querySelectorAll("th").length ? "tr:first th" : "tr:first td", t.querySelectorAll(s).forEach(t2 => {
					const s2 = parseInt(t2.getAttribute("colspan"), 10) || 1,
						i = t2.closest("tr"),
						o = [].indexOf.call(i.parentElement.children, i);
					e[o] || (e[o] = []);
					for (let i2 = 0; i2 < s2; i2++) e[o].push(t2)
				}), t.querySelectorAll("tbody tr").forEach(t2 => this._setupRow(t2, e)), t.querySelectorAll("tfoot tr").forEach(t2 => this._setupRow(t2, e))
			}
			this.options.noResize || this._check(t)
		}), this.options.noResize || (this._tableResizeEvent = () => this._resize(), window.addEventListener("resize", this._tableResizeEvent))
	}
	_setupRow(t, e) {
		t.querySelectorAll(":scope > *").forEach(t2 => {
			if (t2.innerHTML.trim() !== "" && t2.innerHTML !== "&nbsp;" || !this.options.showEmptyCells) {
				const s = [].indexOf.call(t2.parentElement.children, t2);
				let i = "";
				for (let t3 = 0; t3 < e.length; t3++) t3 !== 0 && (i += ": "), i += e[t3][s].textContent;
				t2.setAttribute("data-th", i);
				const o = document.createElement("span");
				if (o.classList.add("bt-content"), this.options.contentWrap && t2.firstChild !== o)
					for (t2.appendChild(o); t2.firstChild !== o;) o.appendChild(t2.firstChild)
			} else t2.classList("bt-hide")
		})
	}
	_check(t) {
		this.options.forceResponsive ? this.options.breakpoint !== null && window.innerWidth <= this.options.breakpoint || this.options.containerBreakpoint !== null && t.parentElement.offsetWidth <= this.options.containerBreakpoint ? this._start(t) : this._end(t) : (t.classList.remove("bt"), t.getBoundingClientRect().left + t.offsetWidth > t.parentElement.offsetWidth ? this._start(t) : this._end(t))
	}
	_start(t) {
		t.classList.add("bt"), this.options.header || t.classList.add("bt--no-header"), this.options.tableWrap && t.closest(".bt-wrapper").classList.add("active")
	}
	_end(t) {
		t.classList.remove("bt", "bt--no-header"), this.options.tableWrap && t.closest(".bt-wrapper").classList.remove("active")
	}
	_resize(t) {
		this.tables.forEach(t2 => {
			t2.getAttribute("data-bt-active") && this._check(t2)
		})
	}
	start() {
		this.tables.forEach(t => {
			this._start(t)
		})
	}
	stop() {
		this.tables.forEach(t => {
			this._end(t)
		})
	}
	restart() {
		this.destroy(), this._getTables(), this._setup()
	}
	destroy() {
		this.tables.forEach(t => {
			if (t.getAttribute("data-bt-active")) {
				t.classList.remove("bt", "bt--no-header"), t.removeAttribute("data-bt-active");
				const e = t.querySelectorAll("td");
				e.forEach(t2 => t2.removeAttribute("data-th")), this.options.contentWrap && e.forEach(t2 => {
					const e2 = t2.querySelector(".bt-content");
					e2 && (t2.innerHTML = e2.innerHTML)
				}), this.options.tableWrap && (t.parentNode.outerHTML = t.parentNode.innerHTML)
			}
		}), this.options.noResize || window.removeEventListener("resize", this._tableResizeEvent)
	}
}
class SizeChart extends HTMLElement {
	constructor() {
		super(), new basictable("#size-table table")
	}
}
customElements.define("size-chart", SizeChart);
class FeaturesImages extends HTMLElement {
	constructor() {
		if (super(), this.selector = document.querySelector(`variant-selects[data-product="${this.dataset.product}"]`), this.selector) this.options = Array.from(this.selector.querySelectorAll("select"), select => select.value);
		else {
			this.selector = document.querySelector(`variant-radios[data-product="${this.dataset.product}"]`);
			const fieldsets = Array.from(this.selector.querySelectorAll("fieldset"));
			this.options = fieldsets.map(fieldset => Array.from(fieldset.querySelectorAll("input")).find(radio => radio.checked).value)
		}
		this.parentProduct = this.selector.hasAttribute("data-parent"), this.galleryEl = this.querySelector('[id^="GalleryViewer"]'), this.slideshowEl = this.querySelector('[id^="Slider-Gallery-"]'), this.optionBase = this.selector.dataset.base.split(",").length;
		const mediaViewer = document.getElementById(`MediaGallery-${this.selector.dataset.section}`).querySelector('[id^="GalleryViewer"]'),
			dataConnect = this.options.slice(0, this.optionBase).join(" / "),
			featureSpecificMedia = mediaViewer.querySelectorAll(`[data-connect="${dataConnect}"][data-feature="true"]`);
		var mediaLoop = new Promise((resolve, reject) => {
			featureSpecificMedia.forEach((element, index, array) => {
				let clonedImage = element.querySelector(".product__media").cloneNode(!0),
					wrapper = document.createElement("li");
				wrapper.classList.add("product__modal-opener--image", "slider__slide"), wrapper.appendChild(clonedImage), this.slideshowEl.appendChild(wrapper), index === array.length - 1 && resolve()
			})
		});
		featureSpecificMedia.length > 0 && mediaLoop.then(() => {
			this.galleryEl.initPages()
		})
	}
}
customElements.define("features-images", FeaturesImages);
class ShopTheLookForm extends HTMLElement {
	constructor() {
		super(), this.addEventListener("change", this.onVariantChange)
	}
	onVariantChange() {
		this.updateOptions(), this.updateMasterId(), this.toggleAddButton(!0, "", !1), this.removeErrorMessage(), this.currentVariant ? (this.updateMedia(), this.updateVariantInput(), this.renderProductInfo()) : (this.toggleAddButton(!0, "", !0), this.setUnavailable())
	}
	updateOptions() {
		this.options = Array.from(this.querySelectorAll('select[name^="options"]'), select => select.value)
	}
	updateMasterId() {
		this.currentVariant = this.getVariantData().find(variant => !variant.options.map((option, index) => this.options[index] === option).includes(!1))
	}
	updateMedia() {
		const featuredImage = this.currentVariant.featured_image;
		if (!featuredImage) return;
		const variantImage = this.closest(".row").querySelector(".media img");
		let featuredImageSrc = featuredImage.src;
		variantImage.removeAttribute("srcset"), variantImage.src = featuredImageSrc.imgURL("750x")
	}
	updateVariantInput() {
		document.querySelectorAll(`#ProductFormShopTheLook-${this.dataset.section}`).forEach(productForm => {
			const input = productForm.querySelector('input[name="id"]');
			input.value = this.currentVariant.id, input.dispatchEvent(new Event("change", {
				bubbles: !0
			}))
		})
	}
	removeErrorMessage() {
		const section = this.closest("section");
		if (!section) return;
		const productForm = section.querySelector("product-form");
		productForm && productForm.handleErrorMessage()
	}
	renderProductInfo() {
		const idSwitcher = this.querySelector('select[name="product-change"]'),
			productUrl = idSwitcher ? idSwitcher.options[idSwitcher.selectedIndex].dataset.url : this.dataset.url;
		fetch(`${productUrl}?variant=${this.currentVariant.id}`).then(response => response.text()).then(responseText => {
			const html = new DOMParser().parseFromString(responseText, "text/html");
			this.productElement = html.querySelector('section[id^="MainProduct-"]'), this.sectionId = this.productElement.dataset.section;
			const destination = document.getElementById(`price-${this.sectionId}`),
				source = html.getElementById(`price-${this.dataset.originalSection?this.dataset.originalSection:this.dataset.section}`);
			source && destination && (destination.innerHTML = source.innerHTML);
			const price = document.getElementById(`price-${this.dataset.section}`);
			this.currentVariant.available || price.classList.add("price--sold-out"), price && price.classList.remove("visibility-hidden"), this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut)
		})
	}
	toggleAddButton(disable = !0, text, modifyClass = !0) {
		const productForm = document.getElementById(`ProductFormShopTheLook-${this.dataset.productid}`);
		if (!productForm) return;
		const addButton = productForm.querySelector('[name="add"]'),
			addButtonText = productForm.querySelector('[name="add"] > span');
		addButton && (disable ? (addButton.setAttribute("disabled", "disabled"), text && (addButtonText.textContent = text)) : (addButton.removeAttribute("disabled"), addButtonText.textContent = window.variantStrings.addToCart))
	}
	setUnavailable() {
		const button = document.getElementById(`ProductFormShopTheLook-${this.dataset.productid}`),
			addButton = button.querySelector('[name="add"]'),
			addButtonText = button.querySelector('[name="add"] > span'),
			price = document.getElementById(`price-${this.dataset.productid}`);
		addButton && (addButtonText.textContent = window.variantStrings.unavailable, price && price.classList.add("visibility-hidden"))
	}
	getVariantData() {
		const idSwitcher = this.querySelector('select[name="product-change"]'),
			currentProductId = idSwitcher ? idSwitcher.options[idSwitcher.selectedIndex].dataset.product : this.dataset.productid,
			variantJSON = this.closest(".shop-the-look__popup-content").querySelector(`[type="application/json"][data-productId="${currentProductId}"]`);
		return this.variantData = JSON.parse(variantJSON.textContent), this.variantData
	}
}
customElements.define("shop-form", ShopTheLookForm);
class CollectionSlider extends HTMLElement {
	constructor() {
		super(), this.slider = this.querySelector(".grid--collection_slider"), this.sliderItems = this.querySelectorAll(".grid__item_collection"), !(!this.slider || this.sliderItems.length < 2) && new Glider(this.slider, {
			slidesToShow: 5,
			slidesToScroll: 1,
			arrows: {
				prev: ".glider-prev",
				next: ".glider-next"
			}
		})
	}
}
customElements.define("collection-slider", CollectionSlider);
class CardSwitcher extends HTMLAnchorElement {
	constructor() {
		super(), this.addEventListener("click", this.colorSwitch)
	}
	colorSwitch(e) {
		e = window.event || e;
		let target = e.target,
			mainImg = this.querySelector(".card-mainimg"),
			hoverImg = this.querySelector(".card-hoverimg");
		if (target.classList.contains("card-variant")) {
			e.preventDefault();
			let id = target.dataset.id,
				hrefSplit = this.href.split("?"),
				combinator = "",
				elems = this.querySelectorAll(".card-information__variant-image");
			[].forEach.call(elems, function(el) {
				el.classList.remove("current")
			}), target.closest(".card-information__variant-image").classList.add("current"), hrefSplit[1] !== void 0 && (combinator = "&" + hrefSplit[1]);
			let newHref = hrefSplit[0] + "?variant=" + id + combinator;
			this.setAttribute("href", newHref);
			let ogSrc = this.src,
				targetSrc = target.dataset.featured;
			if (ogSrc != targetSrc) {
				let targetSrcset = target.dataset.featuredsrcset,
					targetAlt = target.getAttribute("alt");
				mainImg.setAttribute("src", targetSrc), mainImg.setAttribute("srcset", targetSrcset), mainImg.setAttribute("alt", targetAlt);
				let targetHoverSrc = target.dataset.hover;
				if (targetHoverSrc !== "") {
					let targetHoverSrcset = target.dataset.hoversrcset;
					hoverImg.setAttribute("src", targetHoverSrc), hoverImg.setAttribute("srcset", targetHoverSrcset)
				}
			}
		}
	}
}
customElements.define("card-switcher", CardSwitcher, {
	extends: "a"
});

function errorMaker(el, errorMessage) {
	let form_error = el.nextElementSibling;
	(!form_error || !form_error.classList.contains("form_error")) && (form_error = document.createElement("div"), form_error.classList.add("form_error"), el.parentNode.insertBefore(form_error, el.nextSibling)), form_error.classList.add("error"), form_error.innerText = errorMessage
}

function validateEmail(email) {
	return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+")){1,64}@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)
}

function validateVisibleInputs(form) {
	for (var inputs = form.querySelectorAll("input"), i = 0; i < inputs.length; i++)
		if (inputs[i].offsetParent !== null && inputs[i].classList.contains("required")) {
			if (!inputs[i].value) throw inputs[i].classList.add("input_error"), new Error("Required input is empty");
			if (inputs[i].type == "email" && !validateEmail(inputs[i].value)) throw inputs[i].classList.add("input_error"), new Error("The email is invalid")
		} return !0
}
class StepSubmit extends HTMLElement {
	constructor() {
		super(), this.step = this.closest(".block--step"), this.form = this.closest("form"), this.addEventListener("click", this.nextStep.bind(this))
	}
	nextStep() {
		Array.from(this.form.querySelectorAll("input")).forEach(el => el.classList.remove("input_error")), Array.from(this.form.querySelectorAll(".form_error")).forEach(el => el.classList.add("hidden"));
		try {
			validateVisibleInputs(this.form);
			const dataAttributes = this.dataset;
			"target" in dataAttributes ? this.formSubmission(dataAttributes.target, serializeJSON(this.form, !1)) : this.navigateToFormStep(dataAttributes.stepGoto)
		} catch (err) {
			errorMaker(this, err)
		}
	}
	scrollToAction() {
		const mainContentEl = document.getElementById("MainContent");
		window.scrollTo({
			top: mainContentEl.offsetTop,
			behavior: "smooth"
		})
	}
	navigateToFormStep(stepNumber) {
		this.closest(".steps").classList.add("hidden");
		const steps = this.form.querySelectorAll(".block--step");
		steps.forEach(formStepElement => {
			formStepElement.classList.add("hidden")
		}), steps.length == stepNumber && this.form.querySelector(".contact__button").classList.remove("hidden");
		const nextStep = Array.from(steps).filter(step => step.getAttribute("data-step-no") === stepNumber);
		nextStep.length > 0 && (nextStep[0].classList.remove("hidden"), nextStep[0].closest(".col-60").nextSibling.classList.remove("hidden")), this.scrollToAction()
	}
	formSubmission(target, stepJSON) {
		const conditionalEls = this.step.querySelectorAll(`[data-connected="${this.dataset.conditionalConnected}"]`);
		fetch(target, {
			method: "POST",
			body: stepJSON
		}).then(response => response.json()).then(data => {
			this.classList.add("hidden");
			const stepsElement = this.step.closest(".col-60").nextElementSibling;
			stepsElement && stepsElement.classList.contains("steps") && stepsElement.classList.remove("hidden");
			const nextElement = this.nextElementSibling;
			if (nextElement && nextElement.classList.contains("error") && (nextElement.classList.remove("hidden"), nextElement.textContent = data.message), !conditionalEls) return;
			const conditionalResponse = Array.from(conditionalEls).filter(El => El.getAttribute("data-connected-response") === data.response);
			conditionalResponse.length > 0 && conditionalResponse[0].classList.remove("hidden")
		}).catch(error => {
			console.log("error", error)
		})
	}
}
customElements.define("step-button", StepSubmit);



class DonationForm extends HTMLElement {
	constructor() {
		super();
		this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
		this.cartItems = document.querySelector("cart-items");
		this.select = this.querySelector("#donation-program");
		this.destinationEl = this.querySelector("#donation-selected");
		
		// Accordion elements
		this.accordion = this.querySelector('.donation-accordion');
		this.toggle = this.querySelector('.donation-accordion__toggle');
		this.formMain = this.querySelector('.donation-form--main');
		
		if (this.select && this.destinationEl) {
			this.select.addEventListener("change", this.donationSelect.bind(this));
			this.destinationEl.addEventListener("click", this.addDonation.bind(this));
		}
		
		// Initialize accordion
		this.initAccordion();
		
		// Check for pending donations on load
		this.checkPendingDonation();
	}
	
	initAccordion() {
		if (!this.accordion || !this.toggle) return;
		
		const isCollapsed = this.accordion.getAttribute('data-collapsed') === 'true';
		
		if (isCollapsed) {
			this.accordion.classList.remove('is-expanded');
		}
		
		this.toggle.addEventListener('click', this.toggleAccordion.bind(this));
	}
	
	toggleAccordion() {
		const isExpanded = this.accordion.classList.contains('is-expanded');
		
		if (isExpanded) {
			this.accordion.classList.remove('is-expanded');
			this.toggle.setAttribute('aria-expanded', 'false');
		} else {
			this.accordion.classList.add('is-expanded');
			this.toggle.setAttribute('aria-expanded', 'true');
		}
	}
	
	donationSelect(event) {
		this.variantId = event.target.value;
		fetch(`${this.dataset.url}?variant=${this.variantId}&sections=donation-get`)
			.then(response => response.text())
			.then(state => {
				const parsedState = JSON.parse(state);
				if (this.destinationEl) {
					this.destinationEl.classList.remove("hidden");
					this.destinationEl.innerHTML = parsedState["donation-get"];
				}
			});
	}
	
checkPendingDonation() {
	console.log("Checking for pending donation...");
	const pendingDonation = sessionStorage.getItem('pendingDonation');
	console.log("Pending donation data:", pendingDonation);
	
	if (pendingDonation) {
		sessionStorage.removeItem('pendingDonation');
		const { variantId, quantity } = JSON.parse(pendingDonation);
		
		console.log("Adding pending donation - variant:", variantId, "quantity:", quantity);
		
		// Add the donation
		const config = fetchConfig("javascript");
		config.headers["X-Requested-With"] = "XMLHttpRequest";
		delete config.headers["Content-Type"];
		
		const formData = new FormData();
		formData.append("id", variantId);
		formData.append("quantity", quantity);
		
		if (this.cart) {
			console.log("Cart element found:", this.cart);
			// Check if getSectionsToRender exists, otherwise build sections manually
			if (typeof this.cart.getSectionsToRender === 'function') {
				formData.append("sections", this.cart.getSectionsToRender().map(section => section.id));
			} else {
				// Manually specify sections for cart-drawer
				formData.append("sections", "cart-drawer,cart-icon-bubble");
			}
			formData.append("sections_url", window.location.pathname);
		} else {
			console.log("No cart element found");
		}
		
		config.body = formData;
		
		console.log("About to fetch cart add...");
		
		fetch(`${routes.cart_add_url}`, config)
			.then(response => {
				console.log("Fetch response received:", response);
				return response.json();
			})
			.then(response => {
				console.log("Pending donation add response:", response);
				if (this.cart && !response.errors) {
					console.log("Calling renderContents...");
					this.cart.renderContents(response);
				} else if (response.errors) {
					console.error("Error adding pending donation:", response.errors);
				}
			})
			.catch(e => {
				console.error("Error adding pending donation:", e);
			});
	} else {
		console.log("No pending donation found");
	}
}
	
addDonation(event) {
	if (event.target.id != "donation-add") return;
	
	this.quantity = this.destinationEl.querySelector('input[name="quantity"]:checked');
	if (!this.quantity) {
		this.destinationEl.querySelector(".quantity-error").classList.remove("hidden");
		return;
	}
	
	// Get the variant ID directly from the select element
	const variantId = this.select ? this.select.value : null;
	
	console.log("Variant ID from select:", variantId);
	console.log("Quantity value:", this.quantity.value);
	
	if (!variantId) {
		console.error("No variant ID found!");
		return;
	}
	
	// Step 1: Get current cart to find existing donations
	fetch(`${routes.cart_url}.js`)
		.then(response => response.json())
		.then(cart => {
			const donationProductId = this.dataset.donationProductId;
			
			// Find all line items that are donation products
			const donationLineItems = cart.items.filter(item => 
				item.product_id == donationProductId
			);
			
			console.log("Found donation items:", donationLineItems);
			
			// Step 2: If there are existing donations, remove them and reload
			if (donationLineItems.length > 0) {
				const updates = {};
				
				donationLineItems.forEach(item => {
					updates[item.key] = 0;
				});
				
				console.log("Removing existing donation, will add new one after reload");
				console.log("Storing in sessionStorage - variantId:", variantId, "quantity:", this.quantity.value);
				
				// Store the new variant and quantity in sessionStorage
				sessionStorage.setItem('pendingDonation', JSON.stringify({
					variantId: String(variantId),
					quantity: String(this.quantity.value)
				}));
				
				// Verify it was stored
				console.log("Verification - stored data:", sessionStorage.getItem('pendingDonation'));
				
				return fetch(`${routes.cart_update_url}`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({ updates })
				})
				.then(() => {
					// Reload to add the new donation
					window.location.reload();
				});
			} else {
				// Step 3: No existing donation, just add the new one directly
				console.log("No existing donation, adding directly");
				
				const config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				delete config.headers["Content-Type"];
				
				const formData = new FormData();
				formData.append("id", variantId);
				formData.append("quantity", this.quantity.value);
				
				if (this.cart) {
					this.cart.setActiveElement(document.activeElement);
					formData.append("sections", this.cart.getSectionsToRender().map(section => section.id));
					formData.append("sections_url", window.location.pathname);
				}
				
				config.body = formData;
				
				return fetch(`${routes.cart_add_url}`, config)
					.then(response => response.json())
					.then(response => {
						console.log("Direct add response:", response);
						
						if (response.errors) {
							console.error("Cart add error:", response.errors);
							window.location.reload();
							return;
						}
						
						if (this.cartItems) {
							window.location.reload();
						}
						if (this.cart) {
							this.cart.renderContents(response);
						}
					});
			}
		})
		.catch(e => {
			console.error("Error:", e);
		});
}


}
customElements.define("donation-form", DonationForm);

class klaviyoBIS extends HTMLElement {
	constructor() {
		super(), this.form = this.querySelector("form"), this.formSubmit = this.form.querySelector("button"), this.form && this.form.addEventListener("submit", this.bisSubmit.bind(this))
	}
	createJSON(form) {
		const formData = new FormData(form),
			pairs = {};
		for (const [name, value] of formData) pairs[name] = value;
		return pairs
	}
	bisSubmit(event) {
		event.preventDefault();
		const serializedFormData = this.createJSON(this.form),
          variantID = `$custom:::$default:::${serializedFormData.variant}`,
          compiledData = {
            data: {
              type: "back-in-stock-subscription",
              attributes: {
                channels: ["EMAIL"],
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      email: serializedFormData.email
                    }
                  }
                }
              },
              relationships: {
                variant: {
                  data: {
                    type: "catalog-variant",
                    id: variantID
                  }
                }
              }
            }
          },
          dataAttributes = this.form.dataset,
          newsletterData = {
            data: {
              type: "subscription",
              attributes: {
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      subscriptions: {
                        email: {
                          marketing: {
                            consent: "SUBSCRIBED"
                          }
                        }
                      },
                      email: serializedFormData.email
                    }
                  }
                }
              },
              relationships: {
                list: {
                  data: {
                    type: "list",
                    id: "TSMFtq"
                  }
                }
              }
            }
          };
		this.formSubmit.disabled = !0, this.formSubmit.classList.add("animate");
		const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${dataAttributes.companyid}`,
        options = {
          method: "POST",
          headers: {
            accept: "application/json",
            revision: "2024-02-15",
            "content-type": "application/json"
          },
          body: JSON.stringify(compiledData)
        };
    const newsletterUrl = `https://a.klaviyo.com/client/subscriptions?company_id=${dataAttributes.companyid}`,
          newsletterOptions = {
            method: 'POST',
            headers: {
              accept: 'application/vnd.api+json',
              revision: '2025-04-15',
              'content-type': 'application/vnd.api+json'
            },
            body: JSON.stringify(newsletterData)
          };
    fetch(newsletterUrl, newsletterOptions)
      .then(res => res.json())
      .then(res => console.log(res))
      .catch(err => console.error(err));
		fetch(url, options).then(response => {
			this.formSubmit.disabled = !1, this.formSubmit.classList.remove("animate"), setTimeout(() => {
				this.formSubmit.closest(".bis-main").classList.add("hidden"), fetch("https://hook.us1.make.com/5sgkjye92i9k2vy3b3vyv18p26augjdx", {
					method: "PUT",
					headers: {
						"Content-Type": "application/json"
					},
					body: JSON.stringify({
						email: serializedFormData.email,
						iso: dataAttributes.iso
					})
				})
			}, 250)
		}).catch(error => {
			this.formSubmit.disabled = !1, this.formSubmit.classList.remove("animate"), console.error(error)
		})
	}
}
customElements.define("klaviyo-bis", klaviyoBIS);
/*!
 * Jarallax v2.0.4 (https://github.com/nk-o/jarallax)
 * Copyright 2022 nK <https://nkdev.info>
 * Licensed under MIT (https://github.com/nk-o/jarallax/blob/master/LICENSE)
 */
(function(e, t) {
	typeof exports == "object" && typeof module < "u" ? module.exports = t() : typeof define == "function" && define.amd ? define(t) : (e = typeof globalThis < "u" ? globalThis : e || self).jarallax = t()
})(this, function() {
	"use strict";

	function e(e2) {
		document.readyState === "complete" || document.readyState === "interactive" ? e2() : document.addEventListener("DOMContentLoaded", e2, {
			capture: !0,
			once: !0,
			passive: !0
		})
	}
	let t;
	t = typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
	var i = t;
	const {
		navigator: o
	} = i, n = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(o.userAgent);
	let a, s;

	function l() {
		n ? (!a && document.body && (a = document.createElement("div"), a.style.cssText = "position: fixed; top: -9999px; left: 0; height: 100vh; width: 0;", document.body.appendChild(a)), s = (a ? a.clientHeight : 0) || i.innerHeight || document.documentElement.clientHeight) : s = i.innerHeight || document.documentElement.clientHeight
	}
	l(), i.addEventListener("resize", l), i.addEventListener("orientationchange", l), i.addEventListener("load", l), e(() => {
		l()
	});
	const r = [];

	function m() {
		r.length && (r.forEach((e2, t2) => {
			const {
				instance: o2,
				oldData: n2
			} = e2, a2 = o2.$item.getBoundingClientRect(), l2 = {
				width: a2.width,
				height: a2.height,
				top: a2.top,
				bottom: a2.bottom,
				wndW: i.innerWidth,
				wndH: s
			}, m2 = !n2 || n2.wndW !== l2.wndW || n2.wndH !== l2.wndH || n2.width !== l2.width || n2.height !== l2.height, c2 = m2 || !n2 || n2.top !== l2.top || n2.bottom !== l2.bottom;
			r[t2].oldData = l2, m2 && o2.onResize(), c2 && o2.onScroll()
		}), i.requestAnimationFrame(m))
	}
	let c = 0;
	class p {
		constructor(e2, t2) {
			const i2 = this;
			i2.instanceID = c, c += 1, i2.$item = e2, i2.defaults = {
				type: "scroll",
				speed: .5,
				imgSrc: null,
				imgElement: ".jarallax-img",
				imgSize: "cover",
				imgPosition: "50% 50%",
				imgRepeat: "no-repeat",
				keepImg: !1,
				elementInViewport: null,
				zIndex: -100,
				disableParallax: !1,
				disableVideo: !1,
				videoSrc: null,
				videoStartTime: 0,
				videoEndTime: 0,
				videoVolume: 0,
				videoLoop: !0,
				videoPlayOnlyVisible: !0,
				videoLazyLoading: !0,
				onScroll: null,
				onInit: null,
				onDestroy: null,
				onCoverImage: null
			};
			const n2 = i2.$item.dataset || {},
				a2 = {};
			if (Object.keys(n2).forEach(e3 => {
					const t3 = e3.substr(0, 1).toLowerCase() + e3.substr(1);
					t3 && i2.defaults[t3] !== void 0 && (a2[t3] = n2[e3])
				}), i2.options = i2.extend({}, i2.defaults, a2, t2), i2.pureOptions = i2.extend({}, i2.options), Object.keys(i2.options).forEach(e3 => {
					i2.options[e3] === "true" ? i2.options[e3] = !0 : i2.options[e3] === "false" && (i2.options[e3] = !1)
				}), i2.options.speed = Math.min(2, Math.max(-1, parseFloat(i2.options.speed))), typeof i2.options.disableParallax == "string" && (i2.options.disableParallax = new RegExp(i2.options.disableParallax)), i2.options.disableParallax instanceof RegExp) {
				const e3 = i2.options.disableParallax;
				i2.options.disableParallax = () => e3.test(o.userAgent)
			}
			if (typeof i2.options.disableParallax != "function" && (i2.options.disableParallax = () => !1), typeof i2.options.disableVideo == "string" && (i2.options.disableVideo = new RegExp(i2.options.disableVideo)), i2.options.disableVideo instanceof RegExp) {
				const e3 = i2.options.disableVideo;
				i2.options.disableVideo = () => e3.test(o.userAgent)
			}
			typeof i2.options.disableVideo != "function" && (i2.options.disableVideo = () => !1);
			let s2 = i2.options.elementInViewport;
			s2 && typeof s2 == "object" && s2.length !== void 0 && ([s2] = s2), s2 instanceof Element || (s2 = null), i2.options.elementInViewport = s2, i2.image = {
				src: i2.options.imgSrc || null,
				$container: null,
				useImgTag: !1,
				position: "fixed"
			}, i2.initImg() && i2.canInitParallax() && i2.init()
		}
		css(e2, t2) {
			return typeof t2 == "string" ? i.getComputedStyle(e2).getPropertyValue(t2) : (Object.keys(t2).forEach(i2 => {
				e2.style[i2] = t2[i2]
			}), e2)
		}
		extend(e2, ...t2) {
			return e2 = e2 || {}, Object.keys(t2).forEach(i2 => {
				t2[i2] && Object.keys(t2[i2]).forEach(o2 => {
					e2[o2] = t2[i2][o2]
				})
			}), e2
		}
		getWindowData() {
			return {
				width: i.innerWidth || document.documentElement.clientWidth,
				height: s,
				y: document.documentElement.scrollTop
			}
		}
		initImg() {
			const e2 = this;
			let t2 = e2.options.imgElement;
			return t2 && typeof t2 == "string" && (t2 = e2.$item.querySelector(t2)), t2 instanceof Element || (e2.options.imgSrc ? (t2 = new Image, t2.src = e2.options.imgSrc) : t2 = null), t2 && (e2.options.keepImg ? e2.image.$item = t2.cloneNode(!0) : (e2.image.$item = t2, e2.image.$itemParent = t2.parentNode), e2.image.useImgTag = !0), !!e2.image.$item || (e2.image.src === null && (e2.image.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", e2.image.bgImage = e2.css(e2.$item, "background-image")), !(!e2.image.bgImage || e2.image.bgImage === "none"))
		}
		canInitParallax() {
			return !this.options.disableParallax()
		}
		init() {
			const e2 = this,
				t2 = {
					position: "absolute",
					top: 0,
					left: 0,
					width: "100%",
					height: "100%",
					overflow: "hidden"
				};
			let o2 = {
				pointerEvents: "none",
				transformStyle: "preserve-3d",
				backfaceVisibility: "hidden"
			};
			if (!e2.options.keepImg) {
				const t3 = e2.$item.getAttribute("style");
				if (t3 && e2.$item.setAttribute("data-jarallax-original-styles", t3), e2.image.useImgTag) {
					const t4 = e2.image.$item.getAttribute("style");
					t4 && e2.image.$item.setAttribute("data-jarallax-original-styles", t4)
				}
			}
			if (e2.css(e2.$item, "position") === "static" && e2.css(e2.$item, {
					position: "relative"
				}), e2.css(e2.$item, "z-index") === "auto" && e2.css(e2.$item, {
					zIndex: 0
				}), e2.image.$container = document.createElement("div"), e2.css(e2.image.$container, t2), e2.css(e2.image.$container, {
					"z-index": e2.options.zIndex
				}), this.image.position === "fixed" && e2.css(e2.image.$container, {
					"-webkit-clip-path": "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
					"clip-path": "polygon(0 0, 100% 0, 100% 100%, 0 100%)"
				}), e2.image.$container.setAttribute("id", `jarallax-container-${e2.instanceID}`), e2.$item.appendChild(e2.image.$container), e2.image.useImgTag ? o2 = e2.extend({
					"object-fit": e2.options.imgSize,
					"object-position": e2.options.imgPosition,
					"max-width": "none"
				}, t2, o2) : (e2.image.$item = document.createElement("div"), e2.image.src && (o2 = e2.extend({
					"background-position": e2.options.imgPosition,
					"background-size": e2.options.imgSize,
					"background-repeat": e2.options.imgRepeat,
					"background-image": e2.image.bgImage || `url("${e2.image.src}")`
				}, t2, o2))), e2.options.type !== "opacity" && e2.options.type !== "scale" && e2.options.type !== "scale-opacity" && e2.options.speed !== 1 || (e2.image.position = "absolute"), e2.image.position === "fixed") {
				const t3 = function(e3) {
					const t4 = [];
					for (; e3.parentElement !== null;)(e3 = e3.parentElement).nodeType === 1 && t4.push(e3);
					return t4
				}(e2.$item).filter(e3 => {
					const t4 = i.getComputedStyle(e3),
						o3 = t4["-webkit-transform"] || t4["-moz-transform"] || t4.transform;
					return o3 && o3 !== "none" || /(auto|scroll)/.test(t4.overflow + t4["overflow-y"] + t4["overflow-x"])
				});
				e2.image.position = t3.length ? "absolute" : "fixed"
			}
			o2.position = e2.image.position, e2.css(e2.image.$item, o2), e2.image.$container.appendChild(e2.image.$item), e2.onResize(), e2.onScroll(!0), e2.options.onInit && e2.options.onInit.call(e2), e2.css(e2.$item, "background-image") !== "none" && e2.css(e2.$item, {
				"background-image": "none"
			}), e2.addToParallaxList()
		}
		addToParallaxList() {
			r.push({
				instance: this
			}), r.length === 1 && i.requestAnimationFrame(m)
		}
		removeFromParallaxList() {
			const e2 = this;
			r.forEach((t2, i2) => {
				t2.instance.instanceID === e2.instanceID && r.splice(i2, 1)
			})
		}
		destroy() {
			const e2 = this;
			e2.removeFromParallaxList();
			const t2 = e2.$item.getAttribute("data-jarallax-original-styles");
			if (e2.$item.removeAttribute("data-jarallax-original-styles"), t2 ? e2.$item.setAttribute("style", t2) : e2.$item.removeAttribute("style"), e2.image.useImgTag) {
				const i2 = e2.image.$item.getAttribute("data-jarallax-original-styles");
				e2.image.$item.removeAttribute("data-jarallax-original-styles"), i2 ? e2.image.$item.setAttribute("style", t2) : e2.image.$item.removeAttribute("style"), e2.image.$itemParent && e2.image.$itemParent.appendChild(e2.image.$item)
			}
			e2.image.$container && e2.image.$container.parentNode.removeChild(e2.image.$container), e2.options.onDestroy && e2.options.onDestroy.call(e2), delete e2.$item.jarallax
		}
		clipContainer() {}
		coverImage() {
			const e2 = this,
				t2 = e2.image.$container.getBoundingClientRect(),
				i2 = t2.height,
				{
					speed: o2
				} = e2.options,
				n2 = e2.options.type === "scroll" || e2.options.type === "scroll-opacity";
			let a2 = 0,
				l2 = i2,
				r2 = 0;
			return n2 && (0 > o2 ? (a2 = o2 * Math.max(i2, s), s < i2 && (a2 -= o2 * (i2 - s))) : a2 = o2 * (i2 + s), 1 < o2 ? l2 = Math.abs(a2 - s) : 0 > o2 ? l2 = a2 / o2 + Math.abs(a2) : l2 += (s - i2) * (1 - o2), a2 /= 2), e2.parallaxScrollDistance = a2, r2 = n2 ? (s - l2) / 2 : (i2 - l2) / 2, e2.css(e2.image.$item, {
				height: `${l2}px`,
				marginTop: `${r2}px`,
				left: e2.image.position === "fixed" ? `${t2.left}px` : "0",
				width: `${t2.width}px`
			}), e2.options.onCoverImage && e2.options.onCoverImage.call(e2), {
				image: {
					height: l2,
					marginTop: r2
				},
				container: t2
			}
		}
		isVisible() {
			return this.isElementInViewport || !1
		}
		onScroll(e2) {
			const t2 = this,
				o2 = t2.$item.getBoundingClientRect(),
				n2 = o2.top,
				a2 = o2.height,
				l2 = {};
			let r2 = o2;
			if (t2.options.elementInViewport && (r2 = t2.options.elementInViewport.getBoundingClientRect()), t2.isElementInViewport = 0 <= r2.bottom && 0 <= r2.right && r2.top <= s && r2.left <= i.innerWidth, !e2 && !t2.isElementInViewport) return;
			const m2 = Math.max(0, n2),
				c2 = Math.max(0, a2 + n2),
				p2 = Math.max(0, -n2),
				d2 = Math.max(0, n2 + a2 - s),
				g2 = Math.max(0, a2 - (n2 + a2 - s)),
				u = Math.max(0, -n2 + s - a2),
				f = 1 - (s - n2) / (s + a2) * 2;
			let h = 1;
			if (a2 < s ? h = 1 - (p2 || d2) / a2 : c2 <= s ? h = c2 / s : g2 <= s && (h = g2 / s), t2.options.type !== "opacity" && t2.options.type !== "scale-opacity" && t2.options.type !== "scroll-opacity" || (l2.transform = "translate3d(0,0,0)", l2.opacity = h), t2.options.type === "scale" || t2.options.type === "scale-opacity") {
				let e3 = 1;
				0 > t2.options.speed ? e3 -= t2.options.speed * h : e3 += t2.options.speed * (1 - h), l2.transform = `scale(${e3}) translate3d(0,0,0)`
			}
			if (t2.options.type === "scroll" || t2.options.type === "scroll-opacity") {
				let e3 = t2.parallaxScrollDistance * f;
				t2.image.position === "absolute" && (e3 -= n2), l2.transform = `translate3d(0,${e3}px,0)`
			}
			t2.css(t2.image.$item, l2), t2.options.onScroll && t2.options.onScroll.call(t2, {
				section: o2,
				beforeTop: m2,
				beforeTopEnd: c2,
				afterTop: p2,
				beforeBottom: d2,
				beforeBottomEnd: g2,
				afterBottom: u,
				visiblePercent: h,
				fromViewportCenter: f
			})
		}
		onResize() {
			this.coverImage()
		}
	}
	const d = function(e2, t2, ...i2) {
		(typeof HTMLElement == "object" ? e2 instanceof HTMLElement : e2 && typeof e2 == "object" && e2 !== null && e2.nodeType === 1 && typeof e2.nodeName == "string") && (e2 = [e2]);
		const o2 = e2.length;
		let n2, a2 = 0;
		for (; a2 < o2; a2 += 1)
			if (typeof t2 == "object" || t2 === void 0 ? e2[a2].jarallax || (e2[a2].jarallax = new p(e2[a2], t2)) : e2[a2].jarallax && (n2 = e2[a2].jarallax[t2].apply(e2[a2].jarallax, i2)), n2 !== void 0) return n2;
		return e2
	};
	d.constructor = p;
	const g = i.jQuery;
	if (g !== void 0) {
		const e2 = function(...e3) {
			Array.prototype.unshift.call(e3, this);
			const t3 = d.apply(i, e3);
			return typeof t3 != "object" ? t3 : this
		};
		e2.constructor = d.constructor;
		const t2 = g.fn.jarallax;
		g.fn.jarallax = e2, g.fn.jarallax.noConflict = function() {
			return g.fn.jarallax = t2, this
		}
	}
	return e(() => {
		d(document.querySelectorAll("[data-jarallax]"))
	}), d
}), jarallax(document.querySelectorAll(".jarallax"), {
	speed: .2
}), $(document).ready(function() {
	$(document).on("mouseover", ".custom-swatche-list label", function() {
		$(this).parents(".card-wrapper").find(".show-video img.card-mainimg").show(), $(this).parents(".card-wrapper").find(".show-video img.card-mainimg video").hide();
		var imgSrc = $(this).data("vimgsrc");
		console.log(imgSrc), imgSrc && $(this).closest(".card-wrapper").find(".card-mainimg").attr("src", imgSrc).attr("srcset", imgSrc)
	})
}), $(document).ready(function() {
	var recentlyLength = $(".recently-viewed-grid .slick-track li").length;
	recentlyLength == 0 && $(".section-recently").hide()
}), $(document).ready(function() {
	var recentlyLength = $(".recently-viewed-grid .slick-track li").length;
	recentlyLength < 4 && $(".recently-viewed-wrapper .slick-dots").addClass("hide")
}), $(document).ready(function() {
	var gllaryLength = $(".featured-gllary .slick-track .slick-slide").length;
	gllaryLength < 4 && $(".featured-gllary .slick-dots").addClass("hide")
}), $(document).ready(function() {
	var slidesLength = $(".feature-slides .slick-track .slick-slide").length;
	slidesLength < 4 && $(".feature-slides .slick-dots").addClass("hide")
});
//# sourceMappingURL=/s/files/1/0741/3602/7457/t/82/assets/global.js.map?v=1741298094